


import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { ObavijestiPoker } from '../../Components/Layout/ObavijestiPoker.jsx'
import { Game } from '../../Components/Game/Game.jsx'

import { Banners } from '../../Components/Banner/Banners.jsx'
import { MojCasino } from '../../Components/Casino/MojCasino.jsx'
import { BonusItem } from '../../Components/Bonuses/BonusItem.jsx'
import { MaratonPobjednici } from '../../Components/Casino/MaratonPobjednici.jsx'


import { BonusiHorizontalItems } from '../../Components/Poker/HomePage/BonusiHorizontalItems.jsx'
import { IzdvojeniTurniriHorizontalItems } from '../../Components/Poker/HomePage/IzdvojeniTurniriHorizontalItems.jsx'
import { PokerTurnirPobjednici } from '../../Components/Poker/PokerTurnirPobjednici.jsx'

import { PokerLiveInfo } from '../../Components/Poker/PokerLiveInfo.jsx'
import RiveComponent from "../../Components/Shared/RiveComponent/RiveComponent.jsx";

export class PokerHome extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            expandInfoPoker: false,
            expandInfoTurniri: false,
            expandInfoCacheStolovi: false
        }
    }


    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    playPoker() {
        casino.repos.pokerUrlRepo.get().then((res) => {
            window.location.href = res.url;
        });
    }

    render() {
        var isIos = this.props.device.isIos;

        return <div>
            <Header key="header" {...this.state} {...this.props}></Header>
            <div className="white-background">
                <div className="poker-background">

                    <div className="mobile-visible">
                        <div className="poker-background-s"></div>
                        <div className="poker-container">
                            <div className={'poker-download-logo' + (isIos ? ' ios' : '')}></div>
                            
                        </div>
                        <RiveComponent
                            className="rive-element"
                            stateMachines="State Machine 1"
                            artboard= "Artboard"
                            lazyLoad={true}
                            cacheBust={`c=${casino.config.guiCacheVerzija}`}
                            src={`Content/Images/Poker/poker_banner_widget.riv`}
                            useOffscreenRenderer={true}
                            playRequest={true}
                            disablePlayOutsideViewport={{ rootMargin: "-50px 0px 0px 0px" }}
                        />
                    </div>

                    <div className="mobile-hidden">
                        <div className="poker-background-s-wide"></div>
                        <div className="poker-container-wide">
                            <div className={'poker-download-logo-wide' + (isIos ? ' ios' : '')}></div>
                            
                        </div>
                        <div className="center-elements"></div>
                    </div>
                    <div className="poker-container flex-container absolute-bottom">
                        {this.props.user && <div className="poker-play-btn" onClick={this.playPoker}></div>}
                        {!this.props.user && <NavLink  to={{ pathname: "/login", state: { from: this.props.route.location, triggerCallback: true } }} className="poker-play-btn"></NavLink>}
                        {isIos && <a className="poker-download-btn ios"  href="https://itunes.apple.com/hr/app/supersport-poker/id1298042781?mt=8" > </a>}
                        {!isIos && <NavLink to="/poker/download" className="poker-download-btn android" ></NavLink>}
                        <div className="margin-top"><br /></div>
                    </div>
                </div>
                <PokerLiveInfo {...this.props}></PokerLiveInfo>
                <div className="poker-container-wider ">
                    <hr />
                    <h3 className="v3 padding-sides-medium-2">Bonusi</h3>
                    <BonusiHorizontalItems />
                    <hr />
                    <h3 className="v3 padding-sides-medium-2">Izdvojeni turniri</h3>
                    <IzdvojeniTurniriHorizontalItems />
                    <hr />
                    <h3 className="v3 padding-sides-medium-2">Posljednji pobjednici</h3>
                    <PokerTurnirPobjednici showLoadingFn={this.props.showLoadingFn} />
                    <div className="margin-top">
                        <br />
                    </div>
                </div>
                <ObavijestiPoker {...this.props}></ObavijestiPoker>
            </div>
            <div className="poker-text-info">
                <div className="poker-container-wider">
                    <section className="padding-sides-medium-2">
                        <div className="title-container">
                            <h1 className="v3">11 zanimljivosti o pokeru</h1>
                            <img src="content/images/poker/-e-icon_online_poker.png" alt="SuperSport Online Poker"></img>
                        </div>
                        <br />
                        <p>
                            Poker je kartaška igra u kojoj uživaju milijuni ljudi diljem svijeta. Za uspjeh u ovoj igri, koja se može naći u nebrojeno mnogo varijacija, neophodne su sreća i vještina. Samo tako se možete nadati unosnim nagradama, koje na profesionalnim poker turnirima mogu biti čak i multimilijunske.
                        </p>
                        <br />
                        <p>
                            Međutim, postoji puno ljudi koji o pokeru ne znaju puno, što je prava šteta. S tim u vezi, predstavljamo vam 11 interesantnih činjenica o ovoj igri koje možda ranije niste imali prilike saznati.
                        </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}  >
                        <div className="title-container">
                            <h2 className="subtitles">1. Šanse za royal flush u pokeru su gotovo minimalne</h2>
                        </div>
                        <p className="small-darker">
                            Royal flush je kombinacija od pet najvrijednijih poker karata (10, J, Q, K, i A) u istom znaku (srce, pik, tref, karo). Prema dr. Courtney Tayloru, matematičaru s Andersonovog sveučilišta, šanse za ovu kombinaciju u pokeru su 649 740:1. Mnogi profesionalni igrači će vam reći da unatoč godinama igranja nikad nisu dobili ovu kombinaciju.
                            </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">2. Poker se nekad igrao sa samo 20&nbsp;karata</h2>
                        </div>
                        <p className="small-darker">
                            Danas smo navikli na poker sa standardnim špilom od 52 karte, ali on se nekad igrao sa svega 20 karata. Igra se sastojala od četiri igrača. Svakom od njih bi bilo podijeljeno po pet karata, nakon čega bi se vršile oklade. Špil od 52 karte počeo se koristiti tek sredinom 19. stoljeća.
                            </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">3. Prva online poker igra nastala je 1998.&nbsp;godine</h2>
                        </div>
                        <p className="small-darker">
                            Iako je već tada bilo moguće igrati poker preko interneta u nekom obliku, prve online poker igre za pravi novac nastale su tek 1. siječnja 1998. godine, kada je Planet Poker pokrenuo svoju online stranicu. Malo tko je mogao pretpostaviti da će se svega nekoliko godina kasnije online poker pretvoriti u industriju vrijednu više milijardi dolara.
                        </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">4. Poker je službeno „umni sport” od 2010.&nbsp;godine</h2>
                        </div>
                        <p className="small-darker">
                            Od 2010. godine, poker igrači se službeno mogu nazivati sportašima, jer je IMSA (International Mind Sports Association) proglasila ovu kartašku igru umnim sportom. Neke od drugih igara koje su dobile status umnih sportova od strane ove organizacije uključuju šah, bridž, Go, i Xiangqi.
                        </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">5. Texas Hold’em Poker je ilegalan u Texasu</h2>
                        </div>
                        <p className="small-darker">
                            Iako je dobio naziv po ovoj saveznoj državi, Texas Hold’em Poker je danas službeno ilegalan u Texasu. Isto vrijedi i za sve ostale oblike pokera, jer Texas trenutačno ne dozvoljava operiranje kazina bilo u online ili tradicionalnoj (offline) formi.
                        </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">6. Vjeruje se da je poker zasnovan na igri staroj tisuću&nbsp;godina</h2>
                        </div>
                        <p className="small-darker">
                            Mnogi povezuju početke popularnosti pokera s američkim Divljim zapadom, ali nitko ne zna kako je igra točno nastala. Jedni vjeruju da su osnove pokera preuzete iz igre s dominama koja se igrala u Kini u 10. stoljeću. Drugi pak povezuju poker s perzijskom igrom as nas iz 16. stoljeća. Kako bilo, istinu vjerojatno nikada nećemo saznati.
                        </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">7. Prvi oblici današnjeg pokera pojavili su se u New&nbsp;Orleansu</h2>
                        </div>
                        <p className="small-darker">
                            Poker, u obliku u kakvom ga danas znamo, nepobitno potiče iz Sjedinjenih Američkih Država. Ovu igru su prvi igrali francuski doseljenici iz New Orleansa početkom 19. stoljeća. Tada je nosila naziv poque, te su je govornici engleskog jezika radi lakšeg izgovaranja prekrstili u poker.
                        </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">8. Prvo poker natjecanje na televiziji emitirano je 1973.&nbsp;godine</h2>
                        </div>
                        <p className="small-darker">
                            Profesionalni poker turniri se danas često mogu gledati na televiziji ili internetu, a prvi turnir ove vrste emitiran je prije skoro pola stoljeća. World Series of Poker, koji je nastao 1970. godine, odmah je dobio na popularnosti diljem SAD. CBS Sports je otkupio prava prijenosa 1973. i prenosio dramatično natjecanje iz Binion's Horseshoe casina u Las Vegasu, koje je na kraju osvojio Puggy Pearson.
                        </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">9. Najdulja partija pokera trajala je osam&nbsp;godina</h2>
                        </div>
                        <p className="small-darker">
                            Iako nepotvrđeno, mnogi vjeruju u podatak da je najdulja partija pokera trajala više od osam godina. Domaćin ove igre bio je Bird Cage Theatre u Arizoni, gdje je i organiziran takozvani Bird Cage Tournament 1881. godine. Ovo je bila high-limit igra, jer je svaki od sudionika ostvario početni ulog od tisuću dolara, što je u to vrijeme bio ogroman novac. Turnir je službeno završen nakon osam godina, pet mjeseci i tri dana.
                        </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">10. Najveća nagrada u pokeru iznosila je preko 20&nbsp;milijuna dolara</h2>
                        </div>
                        <p className="small-darker">
                            World Series of Poker je 2012. godine organizirao takozvani Big One for One Drop turnir u kojem je buy-in iznosio milijun dolara. Pobjednik turnira bio je tada 33-godišnji Antonio Esfandiari, koji je osvojio preko 18 milijuna dolara. Ovaj rekord ostao je na snazi sve do 2019. godine i Triton Million turnira, na kojem je Bryn Kenney osvojio nestvarnih 20.563.324 dolara. Zanimljiva je činjenica da je zbog dogovora o podjeli glavne nagrade između finalista, Kenney zaradio ovu rekordnu sumu kao osvajač drugog mjesta.
                        </p>
                    </section>
                    <div className="delimiter"></div>
                    <section className={"padding-sides-medium-2"}>
                        <div className="title-container">
                            <h2 className="subtitles">11. Online poker danas igra preko 120&nbsp;milijuna ljudi</h2>
                        </div>
                        <p className="small-darker">
                            Poker je daleko najpopularnija kartaška igra koja se igra za pravi novac. Neke procjene govore da je aktivno ili povremeno igra preko 120 milijuna ljudi, i to samo online, dok preko 50% aktivnih igrača dolazi iz Sjedinjenih Američkih Država.
                        </p>
                    </section>
                </div>
            </div>
        </div>

    }
};
